// Maps screens to their internal (existing) security name (which was originally derived from the Jade form class name).
export const enum securityMappings {
	//
	// Admin
	//
	AccessCodesAdmin = 'LAccessCode',
	AgenciesAdmin = 'LAgency',
	AlertGroupsAdmin = 'AlertGroup',
	BankPrioritiesAdmin = 'LBankPriority',
	DocumentsAdmin = 'LDocument',
	EthnicitiesAdmin = 'LEthnicity',
	EventsAdmin = 'LEvent',
	FavouritesAdmin = 'LMenuFavourites',
	FoldersAdmin = 'LFolders',
	GradesAdmin = 'LGrade',
	HolidayDatesAdmin = 'LHolidayDate',
	JobAdvertisementsAdmin = 'LJobAdvertisment',
	JobDescriptionsAdmin = 'LJobDescription',
	JobTitleLeaveAdmin = 'LJobTitle',
	LeaveAccrualsAdmin = 'LeaveAccrualRule',
	LeaveCodesAdmin = 'LLeaveCode',
	LeaveLimitsAdmin = 'LLeaveLimit',
	MaritalsAdmin = 'LMarital',
	MessagingAdmin = 'LMessageConfiguration',
	NationalitiesAdmin = 'LNationality',
	PayCodesAdmin = 'LPayCode',
	PayrollNumbersAdmin = 'LPayrollNumber',
	PublicApiKeysAdmin = 'PublicApiKey',
	RanksAdmin = 'LRank',
	ResourceAdmin = 'Room',
	SaveLevelsAdmin = 'LSaveLevel',
	StaffSecurityGroup = 'LStaffSecurityGroup',
	SexesAdmin = 'LSex',
	//SCS-210
	GendersAdmin = 'LGender',
	ShiftColoursAdmin = 'LShiftColour',
	ShiftControlLevelsAdmin = 'LShiftControlLevel',
	SkillsCompetenciesAdmin = 'LSkillCompetency',
	StaffExtrasAdmin = 'LStaffExtra',
	StaffSecurityAdmin = 'StaffSecurity',
	StaffTypesAdmin = 'LStaffType',
	StarterLeaverReasonsAdmin = 'LStarterLeaverReason',
	SystemColoursAdmin = 'RotaColoursForm',
	TeamColoursAdmin = 'LTeamColour',
	TemplatesAdmin = 'MergeTemplates',
	ThirdPartyReasonsAdmin = 'LThirdPartyReason',
	TitlesAdmin = 'LTitle',
	TrainingAdmin = 'LTraining',
	UnitsAdmin = 'LUnit',
	WorkflowAdmin = 'WorkflowConfig',
	AuthenticatorSetup = 'AuthenticatorSetup',
	TrustedDevice = 'TrustedDevice',

	//
	// Reports
	//
	AbsenteeismRatesReport = 'AbsenteeismRates',
	BankPaidReport = 'BankPaid',
	BankReport = 'Bank',
	BankStatisticsReport = 'BankStatistics',
	BookingReport = 'Booking',
	CensusReport = 'Census',
	DateSchedulesReport = 'DateSchedules',
	EventsReport = 'Events',
	ExpensesReport = 'Expenses',
	IndividualServiceReport = 'IndividualService',
	JobAdvertsReport = 'JobAdverts',
	LeaveBradfordReport = 'LeaveBradfordScore',
	LeaveLimitsReport = 'LeaveLimits',
	LeaveBalanceExtractReport = 'LeaveBalanceExtract',
	LeaveReport = 'Leave',
	LookupsReport = 'Lookups',
	LostHoursReport = 'LostHours',
	MonthlySchedulesReport = 'MonthlySchedules',
	RankAttendanceReport = 'RankAttendance',
	RequestsReport = 'Requests',
	RollCallReport = 'RollCall',
	SaveLevelsReport = 'SaveLevels',
	ShiftAttendanceReport = 'ShiftAttendance',
	ShiftControlLevelsReport = 'ShiftControlLevels',
	SignoffsReport = 'Signoffs',
	SkillsCompetenciesReport = 'SkillsCompetencies',
	SoftFormExtractReport = 'SoftFormsExtract',
	SoftFormsReport = 'SoftForms',
	StaffContractsReport = 'StaffContracts',
	StaffExtrasReport = 'StaffExtras',
	StaffLeavesReport = 'StaffLeaves',
	StaffLevelsReport = 'StaffLevels',
	StaffRegisterReport = 'StaffRegister',
	StaffTurnoverReport = 'StaffTurnover',
	StartersLeaversReport = 'StartersLeavers',
	TAExceptionsReport = 'TAExceptions',
	TAIndividualReport = 'IndividualTA',
	TimesheetsReport = 'TimeSheets',
	TrainingsReport = 'Trainings',
	TransactionExtractReport = 'TransactionExtract',
	UnitClosureReport = 'UnitLastClosure',
	UnitSchedulesReport = 'UnitSchedules',
	WorkedHoursReport = 'WorkedHours',

	//
	// Management Dashboard reports
	//
	AbsenceMonitoringReport = 'AbsenceMonitoring',
	BudgetReport = 'DashboardBudget',
	EstablishmentReport = 'EstablishmentReturn',
	LostHoursDashboard = 'DashboardLostHours',
	PatientHoursReport = 'DashboardPatientHours',
	RotaAnalysisReport = 'DashboardRotaAnalysis',
	SkillMixNeedsReport = 'DashboardSkillMixNeeds',

	//
	// Other
	//
	Alerts = 'StaffAlerts',
	Availability = 'WorkAvailabilityAvailable',
	BankAuthorise = 'BankAuthoriseUpdate',
	BankMaintenance = 'BankMaintenance',
	BankPaid = 'BankPaidUpdate',
	BankQuery = 'BankQueryUpdate',
	BankStaff = 'BankStaffMaintenance',
	BookingMaintenance = 'BookingMaintenance',
	BookingQuery = 'BookingQuery',
	ContractDates = 'ContractDates',
	CurrentLogins = 'ShowCurrentLogins',
	Dashboards = 'm:Dashboards',
	DateExtensions = 'DateExtensions',
	EventViewer = 'EventViewer',
	ExpenseForms = 'ExpenseForms',
	ExpensesQuery = 'ExpensesQuery',
	ExternalTA = 'ExternalTAndA',
	Favourites = 'Favourites',
	GenericDataLoad = 'GenericDataLoad',
	ItemsMatrix = 'ItemsMatrix',
	JobAdvertsQuery = 'JobAdvertsQuery',
	LeaveAudits = 'LeaveAudits',
	LoneWorkerMaintenance = 'LoneWorkerMaintenance',
	LoneWorkerQuery = 'LoneWorkerQuery',
	Messages = 'StaffMessages',
	MyStaffCare = 'MyStaffCare',
	PayReconciliation = 'PayReconciliation',
	Payroll = 'Payroll',
	ReportAutoRuns = 'ReportAutoRuns',
	RequestsQuery = 'RequestsQuery',
	RolloverLeaveDates = 'RolloverDates',
	ResourceBookings = 'RoomBookings',
	RoomOccupancy = 'RoomOccupancy',
	Rules = 'UnitRules',
	Schedules = 'Schedules',
	SchedulesTimes = 'SchedulesTimes',
	ShiftControl = 'ShiftControl',
	ShiftCorrection = 'ShiftCorrection',
	ShiftRequests = 'ShiftRequests',
	SkillViewer = 'SkillViewer',
	SoftFormsMaintenance = 'SoftFormMaintenance',
	StaffMaintenance = 'StaffMaintenance',
	StaffMaintenanceEndUser = 'StaffMaintenanceEndUser',
	StaffRequests = 'StaffRequests',
	SystemInfo = 'SystemInfo',
	SystemSettings = 'SystemSettings',
	TAAdjustments = 'AdjustClockInClockOut',
	TAExceptionsDashboard = 'Dashboard_TAExceptions',
	TimeOffPattern = 'WorkAvailabilityTimeOff',
	TransactionAudits = 'TransactionAudit',
	Unavailability = 'WorkAvailabilityUnavailable',
	UnitMaintenance = 'UnitMaintenance',
	ViewAudit = 'ViewAudit',
	ViewRequests = 'ViewRequests',
	ViewRequestsEndUser = 'ViewRequestsEndUser',
	WorkPatterns = 'WorkAndLeavePatternEdit',
	AuthenticatorDevices = 'AuthenticatorDevices',
}

/**
 * Represents a mapping from the securityMappings keys to security paths in the old client, used to look up CONTROL settings.
 *
 * The format must ALWAYS be in the form of 'module.screen' even for
 * new screens that had no equivalent in the old client.
 */
export const securityPaths = {
	AlertGroup: 'admin.alertGroup',
	ExpenseForms: 'admin.expenseForms',
	LAccessCode: 'admin.accessCode',
	LAgency: 'admin.agency',
	LBankPriority: 'admin.bankPriority',
	LDocument: 'admin.document',
	LEthnicity: 'admin.ethnicity',
	LEvent: 'admin.event',
	LFolders: 'admin.folders',
	LGrade: 'admin.grade',
	LHolidayDate: 'admin.holidayDate',
	LJobAdvertisment: 'admin.jobAdvertisment',
	LJobDescription: 'admin.jobDescription',
	LJobTitle: 'admin.jobTitle',
	LLeaveCode: 'admin.leaveCode',
	LLeaveLimit: 'admin.leaveLimit',
	LMarital: 'admin.marital',
	LMenuFavourites: 'admin.menuFavourites',
	LMessageConfiguration: 'admin.messageConfiguration',
	LNationality: 'admin.nationality',
	LPayCode: 'admin.payCode',
	LPayrollNumber: 'admin.payrollNumber',
	LRank: 'admin.rank',
	LSaveLevel: 'admin.saveLevel',
	LSex: 'admin.sex',
	//SCS-210
	LGender: 'admin.gender',
	LShiftColour: 'admin.shiftColour',
	LShiftControlLevel: 'admin.shiftControlLevel',
	LSkillCompetency: 'admin.skillCompetency',
	LStaffExtra: 'admin.staffExtra',
	LStaffSecurityGroup: 'admin.staffSecurityGroup',
	LStaffType: 'admin.staffType',
	LStarterLeaverReason: 'admin.starterLeaverReason',
	LTeamColour: 'admin.teamColour',
	LThirdPartyReason: 'admin.thirdPartyReason',
	LTitle: 'admin.title',
	LTraining: 'admin.training',
	LUnit: 'admin.unit',
	LeaveAccrualRule: 'admin.leaveAccrualRule',
	MergeTemplates: 'admin.mergeTemplates',
	PublicApiKey: 'dayByDay.publicApiKey',
	Room: 'admin.room',
	RotaColoursForm: 'admin.rotaColoursForm',
	SoftFormMaintenance: 'admin.softFormMaintenance',
	StaffSecurity: 'admin.staffSecurity',
	WorkflowConfig: 'admin.workflowConfig',

	AbsenteeismRates: 'reports.absenteeismRates',
	Census: 'reports.census',
	DateSchedules: 'reports.dateSchedules',
	Events: 'reports.events',
	Expenses: 'reports.expenses',
	IndividualService: 'reports.individualService',
	IndividualTA: 'reports.individualTa',
	JobAdverts: 'reports.jobAdverts',
	Leave: 'reports.leave',
	LeaveBalanceExtract: 'dayByDay.leaveBalanceExtract',
	LeaveBradfordScore: 'reports.leaveBradfordScore',
	LeaveLimits: 'reports.leaveLimits',
	Lookups: 'reports.lookups',
	LostHours: 'reports.lostHours',
	MonthlySchedules: 'reports.monthlySchedules',
	PayReconciliation: 'reports.payReconciliation',
	Payroll: 'reports.payroll',
	RankAttendance: 'reports.rankAttendance',
	ReportAutoRuns: 'reports.reportAutoRuns',
	Requests: 'reports.requests',
	RollCall: 'reports.rollCall',
	RoomOccupancy: 'reports.roomOccupancy',
	SaveLevels: 'dayByDay.saveLevels',
	ShiftAttendance: 'reports.shiftAttendance',
	ShiftControlLevels: 'dayByDay.shiftControlLevels',
	Signoffs: 'reports.signoffs',
	SkillsCompetencies: 'reports.skillsCompetencies',
	SoftForms: 'reports.softForms',
	SoftFormsExtract: 'reports.softFormsExtract',
	StaffContracts: 'reports.staffContracts',
	StaffExtras: 'reports.staffExtras',
	StaffLeaves: 'reports.staffLeaves',
	StaffLevels: 'reports.staffLevels',
	StaffRegister: 'reports.staffRegister',
	StaffTurnover: 'reports.staffTurnover',
	StartersLeavers: 'reports.startersLeavers',
	TAExceptions: 'reports.taExceptions',
	TimeSheets: 'reports.timeSheets',
	Trainings: 'reports.trainings',
	TransactionExtract: 'reports.transactionExtract',
	UnitLastClosure: 'dayByDay.unitLastClosure',
	UnitSchedules: 'reports.unitSchedules',
	WorkedHours: 'reports.workedHours',

	EventViewer: 'staff.eventViewer',
	ExpensesQuery: 'staff.expensesQuery',
	Favourites: 'staff.favourites',
	ItemsMatrix: 'staff.itemsMatrix',
	JobAdvertsQuery: 'staff.jobAdvertsQuery',
	MyStaffCare: 'staff.myStaffCare',
	RequestsQuery: 'staff.requestsQuery',
	ShiftRequests: 'staff.shiftRequests',
	SkillViewer: 'staff.skillViewer',
	StaffAlerts: 'staff.staffAlerts',
	StaffMaintenanceEndUser: 'staff.staffMaintenanceEndUser',
	StaffMaintenance: 'staff.staffMaintenance',
	StaffMessages: 'staff.staffMessages',
	StaffRequests: 'staff.staffRequests',
	ViewRequests: 'staff.viewRequests',
	ViewRequestsEndUser: 'staff.viewRequestsEndUser',
	WorkAndLeavePatternEdit: 'staff.workAndLeavePatternEdit',
	WorkAvailabilityAvailable: 'staff.workAvailabilityAvailable',
	WorkAvailabilityTimeOff: 'staff.workAvailabilityTimeOff',
	WorkAvailabilityUnavailable: 'staff.workAvailabilityUnavailable',

	Bank: 'bookings.bank',
	BankAuthoriseUpdate: 'bookings.bankAuthoriseUpdate',
	BankMaintenance: 'bookings.bankMaintenance',
	BankPaid: 'bookings.bankPaid',
	BankPaidUpdate: 'bookings.bankPaidUpdate',
	BankQueryUpdate: 'bookings.bankQueryUpdate',
	BankStaffMaintenance: 'bookings.bankStaffMaintenance',
	BankStatistics: 'bookings.bankStatistics',
	Booking: 'bookings.booking',
	BookingMaintenance: 'bookings.bookingMaintenance',
	BookingQuery: 'bookings.bookingQuery',
	LoneWorkerMaintenance: 'bookings.loneWorkerMaintenance',
	LoneWorkerQuery: 'bookings.loneWorkerQuery',
	RoomBookings: 'bookings.romBookings',

	AbsenceMonitoring: 'dayByDay.absenceMonitoring',
	AdjustClockInClockOut: 'dayByDay.adjustClockInClockOut',
	ContractDates: 'dayByDay.contractDates',
	DashboardBudget: 'dayByDay.dashboardBudget',
	DashboardLostHours: 'dayByDay.dashboardLostHours',
	DashboardPatientHours: 'dayByDay.dashboardPatientHours',
	DashboardRotaAnalysis: 'dayByDay.dashboardRotaAnalysis',
	DashboardSkillMixNeeds: 'dayByDay.dashboardSkillMixNeeds',
	Dashboard_TAExceptions: 'dayByDay.dashboardTAExceptions',
	DateExtensions: 'dayByDay.dateExtensions',
	EstablishmentReturn: 'dayByDay.establishmentReturn',
	ExternalTAndA: 'dayByDay.externalTAndA',
	GenericDataLoad: 'dayByDay.genericDataLoad',
	LeaveAudits: 'dayByDay.leaveAudits',
	RolloverDates: 'dayByDay.rolloverDates',
	ShiftControl: 'dayByDay.shiftControl',
	ShiftCorrection: 'dayByDay.shiftCorrection',
	ShowCurrentLogins: 'dayByDay.showCurrentLogins',
	SystemInfo: 'dayByDay.systemInfo',
	SystemSettings: 'dayByDay.systemSettings',
	TransactionAudit: 'dayByDay.transactionAudit',
	ViewAudit: 'dayByDay.viewAudit',

	Schedules: 'units.schedules',
	SchedulesTimes: 'units.schedulesTimes',
	UnitMaintenance: 'units.unitMaintenance',
	UnitRules: 'units.unitRules',

	'm:Dashboards': 'dashboards.dashboards',

	AuthenticatorDevices: 'staff.authenticatorDevices',
	TrustedDevice: 'staff.trustedDevice',
};

/**
 * A hash that takes a security path - e.g. staff.staffMaintenance and returns the security key - e.g. StaffMaintenance.
 */
export const securityPathsReverseLookup = Object.keys(securityPaths as Record<string, string>).reduce((dict, key) => {
	dict[securityPaths[key]] = key;
	return dict;
}, {});
